<script setup lang="ts">
defineProps<{
  messageData: {
    text: string;
    html?: string;
  };
}>();
</script>

<template>
  <template v-if="!messageData.html">
    {{ messageData.text }}
  </template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-else class="html-output" v-html="messageData.html" />
</template>

<style>
/* Can't be scoped because of v-html */
.html-output p {
  margin: 0;
}
</style>
